import React from "react";
import { Box, Avatar } from "@mui/material";

function CircleImage({ size, url, firstName = "", lastName = "", onClick }) {
  const initials = React.useMemo(() => {
    if (firstName.length > 0 && lastName.length > 0) {
      return `${firstName[0]}${lastName[0]}`;
    } else if (firstName.length > 0) {
      return `${firstName[0]}`;
    } else if (lastName.length > 0) {
      return `${lastName[0]}`;
    }
    return "";
  }, [firstName, lastName]);

  // Handle click with proper event propagation
  const handleClick = (e) => {
    if (onClick) {
      // Stop propagation to avoid multiple handlers firing
      e.stopPropagation();
      onClick(e);
    }
  };

  return (
    <Box
      data-testid="CircleImage"
      style={{
        height: size,
        width: size, // Make width equal to height for perfect circle
        borderRadius: "50%", // Make the box round
        overflow: "hidden", // Hide any overflow
        cursor: onClick ? "pointer" : "default",
        display: "flex", // Ensure proper centering of the avatar
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={handleClick}
    >
      <Avatar
        src={url ? url : null}
        style={{
          width: "100%",
          height: "100%",
          fontSize: `${size / 2.5}px`, // Properly scale the initials based on circle size
        }}
        alt={initials}
        // Add onClick to Avatar as well to ensure clicks are captured
        onClick={handleClick}
      >
        {initials}
      </Avatar>
    </Box>
  );
}

export default CircleImage;
